export default [
  {
    path: 'memberCenter',
    component: () => import('@/views/member/memberCenter'),
    name: 'MemberCenter',
    meta: { title: '会员中心', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'recommendGift',
    component: () => import('@/views/member/recommendGift'),
    name: 'RecommendGift',
    meta: { title: '推荐有礼', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'memberPayPlace',
    component: () => import('@/views/member/memberPay/place'),
    name: 'MemberPayPlace',
    meta: { title: '支付', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'memberPaySubmit',
    component: () => import('@/views/member/memberPay/submit'),
    name: 'MemberPaySubmit',
    meta: { title: '支付确认', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'goodsOrder',
    component: () => import('@/views/member/goodsOrder'),
    name: 'GoodsOrder',
    meta: { title: '我的订单', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'memberAssets',
    component: () => import('@/views/member/memberAssets'),
    name: 'MemberAssets',
    meta: { title: '企业资产', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'entAssets',
    component: () => import('@/views/entAssets'),
    name: 'EntAssets',
    meta: { title: '企业资产', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'rebateAccountSeq',
    component: () => import('@/views/member/memberAssets/rebateAccount/accountSeq'),
    name: 'RebateAccountSeq',
    meta: { title: '奖励金账户明细', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'pointsAccountSeq',
    component: () => import('@/views/member/memberAssets/pointsAccount/accountSeq'),
    name: 'PointsAccountSeq',
    meta: { title: '积分账户明细', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'welfareMall',
    component: () => import('@/views/member/welfareMall'),
    name: 'WellfareMall',
    meta: { title: '福利商城', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'promotion',
    component: () => import('@/views/member/welfareMall/promotion'),
    name: 'Promotion',
    meta: { title: '促销商品', icon: 'a-up', noCache: true },
    hidden: true,
  },
  {
    path: 'goodsDetail/:id',
    component: () => import('@/views/member/welfareMall/goodsDetail'),
    name: 'GoodsDetail',
    meta: { title: '商品详情', icon: 'a-up', noCache: true },
    hidden: true,
  }
]
